<template>
  <div class="mt-5" v-observe-visibility="{
          callback: visibilityChanged,
          once: true,
          rootMargin: '-300px'
        }">
        
    <section class="bg-blue">
      <div class="container">
        <h2 id="coalition">{{ $t('coalition_question') }}</h2>

        <i18n tag="p" class="answer" path="coalition_answer">
          <template v-slot:coalition_percentage>
            <span class="emph">{{ topCoalition.x | percentage(0) }}</span>
          </template>
          <template v-slot:coalition_title>
            <span class="emph">{{ topCoalition.title }}</span> 
          </template>
        </i18n>
        
        <BarChart :data="chartData" v-if="!timecourse" @hover="hovered" :elementHeight="dashboard ? 450 : 300"  />
        <LineChart :data="lineChartData" v-if="timecourse"  @hover="hovered" :elementHeight="300" :dateFormat="'%b \'%y'"/>
        <div class="text-center mt-2" v-if="!dashboard">
          <button @click="timecourse = false" class="switch" :class="{active: !timecourse}">{{ $t('other_newest_forecast') }}</button>
          <button @click="timecourse = true" class="switch" :class="{active: timecourse}">{{ $t('other_historical_forecasts') }}</button>
        </div>
      </div>
    </section>

    <section v-if="!dashboard">
      <div class="container">
        <i18n tag="p" path="coalition_text_1">
          <template v-slot:prop_of_government>
            <a v-on:click="scrollTo('partofgov')">{{ $t('other_prop_of_government')}}</a>
          </template>
          <template v-slot:here>
            <router-link :to="'/' + $i18n.locale + '/faq#faq-4'">{{ $t('other_here')}}</router-link>
          </template>
        </i18n>

      <i18n path="coalition_text_2" tag="p">
      </i18n>

      <i18n path="coalition_text_3" tag="p">
      </i18n>

      <i18n path="coalition_text_4" tag="p">
      </i18n>

      <i18n path="coalition_text_5" tag="p">
      </i18n>

      </div>
    </section>

  </div>
</template>

<script>
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import { filter, map } from "lodash";

export default {
  name: "Coalition",
  components: {
    BarChart,
    LineChart,
  },
  data: function () {
    return {
      timecourse: false,
      index: 0,
    };
  },
  computed: {
    chartData() {
      return this.$store.getters.topFiveCoalitionsChartData;
    },
    lineChartData() {
      return this.$store.getters.topFiveCoalitionsLineChartData;
    },
    coalitionProb() {
      return this.$store.getters.coalitionProb;
    },
    topCoalition() {
      if (
        this.chartData &&
        this.chartData.points &&
        this.chartData.points.length > 0
      ) {
        return this.chartData.points[this.index];
      }
      return {
        y: 0,
        title: "NA",
      };
    },
    coalitionGruene() {
      let p =
        this.coalitionEstimateById(9) +
        this.coalitionEstimateById(10) +
        this.coalitionEstimateById(11) +
        this.coalitionEstimateById(12) +
        this.coalitionEstimateById(13) +
        this.coalitionEstimateById(17) ;

      return Math.round(p * 100) / 100;
    },
    coalitionUnion() {
      let p =
        this.coalitionEstimateById(1) +
        this.coalitionEstimateById(4) +
        this.coalitionEstimateById(7) +
        this.coalitionEstimateById(8) +
        this.coalitionEstimateById(14) +
        this.coalitionEstimateById(16) ;

      return Math.round(p * 100) / 100;
    },
  },
  methods: {
    hovered(id) {
      let ids = map(this.chartData.points, "id");
      let index = ids.indexOf(id);

      if (index > -1) this.index = index;
    },
    coalitionEstimateById(id) {
      if (this.coalitionProb && this.coalitionProb.length > 0) {
        let point = filter(this.coalitionProb, { id: id });
        if (point.length > 0) return point[0].estimate;
        else return 0;
      }
      return 0;
    },
    percParty(id) {
      let forecast = this.$store.getters.forecastTableData;

      if (forecast.length == 0) return 0;

      let party = filter(forecast, { party_id: id })[0];

      return party.forecast;
    },
    visibilityChanged (isVisible) {
      if (isVisible) {
         this.$store.dispatch('getForecast');
         this.$store.dispatch('getCoalitionProb');
      }
    },
    scrollTo (id) {
      // scroll to correct position
      let navbar = document.getElementsByClassName("navbar-container")[0];
      let question = document.getElementById(id);
      let topOfElement = question.offsetTop - navbar.offsetHeight - 10;
      window.scroll({ top: topOfElement, behavior:'smooth' });
    }
  },
};
</script>